import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const ConfigImpuestoTarifa = {

    async Get() {  return await methods.Get("ConfigImpuestoTarifa/Get" ); },
    async Post(data) { return await methods.Post("ConfigImpuestoTarifa/Post", data) },
    async Put(qs, data) { return await methods.Put("ConfigImpuestoTarifa/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("ConfigImpuestoTarifa/Delete" + useParamsJson(qs)) }
};

export default ConfigImpuestoTarifa;